module.exports = [{
      plugin: require('../.yarn/$$virtual/gatsby-remark-images-virtual-ccc9caea5e/0/cache/gatsby-remark-images-npm-3.3.4-f2d4791f45-3.zip/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":900,"quality":100},
    }]
